<template>
  <div class="app-container crm-detail">
    <el-card class="crm-detail-base" shadow="never">
      <el-row>
        <el-col :span="12">
          <span class="base-name">{{detail.contractNum || '暂无合同编号'}}</span>
        </el-col>
        <el-col :span="12" v-if="detail.id" align="right">
          <!-- 合同状态 10-待审批 20-审批中 30-已驳回 40-待线下审批 50-已终止 60-签约中 70-待财务确认 80-已签约 -->
          <el-button v-if="detail.canEnd" type="text" @click="handleOption(2)">终止</el-button>
          <el-button v-if="detail.canConfirmSign" type="text" @click="handleOption(3)">确认签约</el-button>
          <el-button v-if="detail.canFinanceConfirm" type="text" @click="handleOption(4)">{{ isRjtTenant ? '纸质存档确认' : '财务确认' }}</el-button>
          <el-button v-if="detail.canMaintainArchive" type="text" @click="handleArchiveNo">维护档案号</el-button>
          <el-button v-if="detail.canMaintainArchive" type="text" @click="handleRetryArchiveRecognition">重新识别存档方式</el-button>
          <el-button v-if="detail.canCancelApproval" type="text" @click="handleOption(5)">撤回审批</el-button>
          <el-button v-if="detail.canCreateApproval" type="text" @click="handleOption(6)">发起审批</el-button>
          <el-button v-if="detail.canAssign" type="text" @click="handleAssign()">分配</el-button>
          <el-button type="text" @click="exportContractDocument">未盖章合同</el-button>
        </el-col>
      </el-row>
      <ConfirmCheck ref="confirmCheckRef" @success="refreshDetailAndLog"></ConfirmCheck>
      <EndDialog ref="endDialogRef" @success="refreshDetailAndLog"></EndDialog>
      <ConfirmContract ref="confirmContractRef" @success="refreshDetailAndLog"></ConfirmContract>
      <FinanceConfirm ref="financeConfirmRef" @success="refreshDetailAndLog"></FinanceConfirm>
      <ContractArchive ref="contractArchiveRef" @success="refreshDetailAndLog"></ContractArchive>
      <div>
        <div class="base-item">
          <div class="title label">签约客户</div>
          <el-link type="primary" class="crm-link-wrap" :underline="false" @click="toCustomerDetail()">{{detail.customerName}}</el-link>
        </div>
        <div class="base-item">
          <div class="title label">商机</div>
          <el-link type="primary" class="crm-link-wrap" :underline="false" @click="toBusinessDetail()">{{detail.businessName}}</el-link>
        </div>
        <div class="base-item">
          <div class="title label">合同状态</div>
          <div class="value">{{detail.contractStatusDesc}}</div>
        </div>
        <div class="base-item">
          <div class="title label">总金额（元）</div>
          <div class="value">{{amountFormat(detail.contractAmount)}}</div>
        </div>
        <div class="base-item">
          <div class="title label">已回款（元）</div>
          <div class="value">{{amountFormat(detail.fundedAmount)}}</div>
        </div>
        <div class="base-item">
          <div class="title label">回款进度</div>
          <div class="value">{{detail.fundProcess}}%</div>
        </div>
        <div class="base-item">
          <div class="title label">签约日期</div>
          <div class="value">{{detail.contractSignDate}}</div>
        </div>
        <div v-if="isRjtTenant" class="base-item">
          <div class="title label">存档方式</div>
          <div class="value">{{detail.archiveMethodDesc || '待判定'}}</div>
        </div>
        <div v-if="isRjtTenant" class="base-item">
          <div class="title label">档案号</div>
          <div class="value">{{detail.archiveNo || '待维护'}}</div>
        </div>
      </div>
    </el-card>
    <el-row :gutter="16">
      <div class="sidebar-toggle">
        <el-button type="text" @click="sidebarCollapsed = !sidebarCollapsed">
          {{ sidebarCollapsed ? '展开' : '收起' }}
        </el-button>
      </div>
      <el-col :span="sidebarCollapsed ? 24 : 16">
        <el-card class="crm-detail-main" v-if="detail.id" shadow="never">
          <el-tabs v-model="activeName" @tab-click="handleTabClick" :stretch="true">
            <el-tab-pane label="跟进计划" name="followPlan">
              <el-tabs v-model="followPlanActiveName" :stretch="true">
                <el-tab-pane label="跟进记录" name="follow">
                  <FollowAdd ref="followAddRef" :targetId="detail.id" targetType="contract" @success="handleAfterFollowAdd"></FollowAdd>
                  <div style="height: 473px">
                    <FollowList :targetId="detail.id" targetType="contract" :hideCurrentTargetInfo="true" ref="followListRef"></FollowList>
                  </div>
                </el-tab-pane>
                <el-tab-pane label="工作计划" name="workPlan">
                  <WorkPlan ref="workPlanRef" :targetId="detail.id" targetType="contract" :managerId="detail.assignUserId" @success="handleAfterWorkPlanAdd"></WorkPlan>
                </el-tab-pane>
              </el-tabs>
            </el-tab-pane>
            <el-tab-pane v-if="canViewCollections" :label="'回款管理'" name="contractInfo">
              <contractDetailInfo ref="contractInfoRef" @success="refreshDetailAndLog" :contractId="detail.id" height="630"></contractDetailInfo>
            </el-tab-pane>
            <el-tab-pane label="项目财务一览" name="financeOverview">
              <div class="finance-overview" v-loading="financeOverviewLoading">
                <div class="finance-overview-head">
                  <div>
                    <div class="finance-overview-title">项目财务一览</div>
                    <div class="finance-overview-desc">基于合同、回款、开票、报价、履约采购和项目成本汇总，只读展示，不影响原有合同流程。</div>
                  </div>
                  <div class="finance-overview-actions">
                    <el-button size="mini" @click="queryFinanceOverview">刷新</el-button>
                    <el-button v-if="canViewCollections" size="mini" type="primary" plain @click="switchFinanceTarget('contractInfo')">回款管理</el-button>
                    <el-button size="mini" type="primary" plain @click="switchFinanceTarget('contractInvoice')">开票记录</el-button>
                    <el-button size="mini" type="primary" plain @click="switchFinanceTarget('fulfillment')">履约项目</el-button>
                    <el-button size="mini" type="primary" plain @click="switchFinanceTarget('cost')">项目成本</el-button>
                  </div>
                </div>
                <div v-if="financeOverview">
                  <div class="finance-section">
                    <div class="finance-section-title">项目概览</div>
                    <el-row :gutter="12">
                      <el-col :xs="24" :sm="12" :lg="6">
                        <div class="finance-meta-item">
                          <span>合同编号</span>
                          <strong>{{financeText(financeOverview.contractSummary.contractNum)}}</strong>
                        </div>
                      </el-col>
                      <el-col :xs="24" :sm="12" :lg="6">
                        <div class="finance-meta-item">
                          <span>客户</span>
                          <strong>{{financeText(financeOverview.contractSummary.customerName)}}</strong>
                        </div>
                      </el-col>
                      <el-col :xs="24" :sm="12" :lg="6">
                        <div class="finance-meta-item">
                          <span>商机</span>
                          <strong>{{financeText(financeOverview.contractSummary.businessName)}}</strong>
                        </div>
                      </el-col>
                      <el-col :xs="24" :sm="12" :lg="6">
                        <div class="finance-meta-item">
                          <span>负责人</span>
                          <strong>{{financeText(financeOverview.contractSummary.assignUserName)}}</strong>
                        </div>
                      </el-col>
                    </el-row>
                  </div>

                  <el-row :gutter="12" class="finance-kpi-grid">
                    <el-col :xs="24" :sm="12" :lg="6">
                      <div class="finance-kpi">
                        <div class="finance-kpi-label">合同金额</div>
                        <div class="finance-kpi-value">￥{{financeAmount(financeOverview.receivableSummary.contractAmount)}}</div>
                        <div class="finance-kpi-sub">回款进度 {{financePercent(financeOverview.receivableSummary.receiveProgress)}}</div>
                      </div>
                    </el-col>
                    <el-col :xs="24" :sm="12" :lg="6">
                      <div class="finance-kpi">
                        <div class="finance-kpi-label">已回款</div>
                        <div class="finance-kpi-value">￥{{financeAmount(financeOverview.receivableSummary.receivedAmount)}}</div>
                        <div class="finance-kpi-sub">未回款 ￥{{financeAmount(financeOverview.receivableSummary.unreceivedAmount)}}</div>
                      </div>
                    </el-col>
                    <el-col :xs="24" :sm="12" :lg="6">
                      <div class="finance-kpi">
                        <div class="finance-kpi-label">已开票</div>
                        <div class="finance-kpi-value">￥{{financeAmount(financeOverview.invoiceSummary.invoiceAmount)}}</div>
                        <div class="finance-kpi-sub">开票进度 {{financePercent(financeOverview.invoiceSummary.invoiceProgress)}}</div>
                      </div>
                    </el-col>
                    <el-col :xs="24" :sm="12" :lg="6">
                      <div class="finance-kpi">
                        <div class="finance-kpi-label">当前预计毛利率</div>
                        <div class="finance-kpi-value">{{financePercent(financeOverview.profitSummary.currentGrossMargin)}}</div>
                        <div class="finance-kpi-sub">当前预计毛利 ￥{{financeAmount(financeOverview.profitSummary.currentGrossProfit)}}</div>
                      </div>
                    </el-col>
                  </el-row>

                  <el-row :gutter="12">
                    <el-col :xs="24" :lg="12">
                      <div class="finance-section">
                        <div class="finance-section-title">成本口径</div>
                        <div class="finance-row">
                          <span>报价预计成本</span>
                          <strong>￥{{financeAmount(financeOverview.costSummary.quoteCostAmount)}}</strong>
                        </div>
                        <div class="finance-row">
                          <span>履约采购预计成本</span>
                          <strong>￥{{financeAmount(financeOverview.costSummary.fulfillmentExpectedCostAmount)}}</strong>
                        </div>
                        <div class="finance-row">
                          <span>采购确认成本</span>
                          <strong>￥{{financeAmount(financeOverview.costSummary.procurementConfirmedCostAmount)}}</strong>
                        </div>
                        <div class="finance-row">
                          <span>原项目成本</span>
                          <strong>￥{{financeAmount(financeOverview.costSummary.legacyCostAmount)}}</strong>
                        </div>
                        <div class="finance-row finance-row-strong">
                          <span>当前采用成本</span>
                          <strong>￥{{financeAmount(financeOverview.costSummary.currentCostAmount)}}</strong>
                        </div>
                        <div class="finance-note">
                          当前口径：{{financeText(financeOverview.costSummary.currentCostSource)}}；{{financeText(financeOverview.costSummary.currentCostFormula)}}
                        </div>
                      </div>
                    </el-col>
                    <el-col :xs="24" :lg="12">
                      <div class="finance-section">
                        <div class="finance-section-title">利润口径</div>
                        <div class="finance-row">
                          <span>报价预计毛利</span>
                          <strong>￥{{financeAmount(financeOverview.profitSummary.quoteGrossProfit)}} / {{financePercent(financeOverview.profitSummary.quoteGrossMargin)}}</strong>
                        </div>
                        <div class="finance-row">
                          <span>当前预计毛利</span>
                          <strong>￥{{financeAmount(financeOverview.profitSummary.currentGrossProfit)}} / {{financePercent(financeOverview.profitSummary.currentGrossMargin)}}</strong>
                        </div>
                        <div class="finance-row">
                          <span>实际毛利</span>
                          <strong>￥{{financeAmount(financeOverview.profitSummary.actualGrossProfit)}} / {{financePercent(financeOverview.profitSummary.actualGrossMargin)}}</strong>
                        </div>
                        <div class="finance-row">
                          <span>回款计划金额</span>
                          <strong>￥{{financeAmount(financeOverview.receivableSummary.planReceivableAmount)}}</strong>
                        </div>
                        <div class="finance-row">
                          <span>逾期金额</span>
                          <strong>￥{{financeAmount(financeOverview.receivableSummary.overdueAmount)}}</strong>
                        </div>
                        <div class="finance-note">
                          实际毛利按已回款减原项目成本展示，后续可接入采购付款、费用报销后升级为实际利润。
                        </div>
                      </div>
                    </el-col>
                  </el-row>

                  <div class="finance-section">
                    <div class="finance-section-title">财务风险提示</div>
                    <el-alert
                      v-for="item in financeOverview.riskList"
                      :key="item.title"
                      class="finance-alert"
                      :type="financeRiskType(item.level)"
                      :title="item.title"
                      :description="item.description"
                      show-icon
                      :closable="false">
                      <el-button v-if="item.actionTab" type="text" size="mini" @click="switchFinanceTarget(item.actionTab)">去处理</el-button>
                    </el-alert>
                  </div>

                  <div class="finance-section">
                    <div class="finance-section-title">数据来源</div>
                    <el-table :data="financeOverview.sourceList" size="mini" border>
                      <el-table-column prop="moduleName" label="模块" width="120"/>
                      <el-table-column prop="dataSource" label="来源" width="120"/>
                      <el-table-column prop="description" label="说明" min-width="320"/>
                      <el-table-column label="操作" width="90">
                        <template slot-scope="scope">
                          <el-button v-if="scope.row.actionTab" type="text" size="mini" @click="switchFinanceTarget(scope.row.actionTab)">查看</el-button>
                          <span v-else>-</span>
                        </template>
                      </el-table-column>
                    </el-table>
                  </div>
                </div>
                <div v-else class="finance-empty">暂无项目财务数据</div>
              </div>
            </el-tab-pane>
            <el-tab-pane label="详细资料" name="detail">
              <el-row>
                <el-col align="right" style="height: 40px;">
                  <el-button type="text" @click="handleEdit" v-if="!editModel" :disabled="!detail.id">编辑资料</el-button>
                  <el-button type="primary" @click="handleEditSave" v-if="editModel">保存</el-button>
                  <el-button  @click="editModel=false" v-if="editModel">取消</el-button>
                </el-col>
              </el-row>
              <el-form :model="updateData" :rules="updateRules" ref="updateForm" label-width="130px" :hide-required-asterisk="!editModel">
                <el-row class="card-item">
                  <p class="card-title">合同信息</p>
                    <el-row>
                      <el-col :xs="24" :md="12" :lg="12">
                        <el-form-item label="合同编号:" prop="contractNum">
                          <span class="value">{{detail.contractNum}}</span>
                        </el-form-item>
                      </el-col>
                      <el-col :xs="24" :md="12" :lg="12">
                        <el-form-item label="审批流程:" prop="approvalTemplateCode">
                          <el-radio-group v-if="editModel && detail.contractStatus === 10" v-model="updateData.approvalTemplateCode">
                            <el-radio label="moProcess">膜组件、膜元件流程</el-radio>
                            <el-radio label="integrationProcess">一体化流程</el-radio>
                          </el-radio-group>
                          <span v-else class="value">{{detail.approvalTemplateCodeDesc}}</span>
                          <div>
                            <el-popover placement="right" width="450" trigger="hover">
                              <div v-if="detail.workOrderId && detail.contractStatus !== 10">
                                本合同实际审批节点以审批记录为准；以下说明仅适用于新发起合同。
                              </div>
                              <div v-else-if="isRjtTenant">
                                瑞洁特新流程（启用后适用，实际以本单审批记录为准）<br>
                                1. 膜组件、膜元件审批流程<br>
                                发起人→部门经理→技术负责人→副总工→财务总监→总经理→资金会计<br>
                                2. 一体化审批流程<br>
                                发起人→部门经理→（技术负责人、交付负责人并行审批）→副总工→财务总监→总经理→资金会计<br>
              普通审批节点无人时自动跳过并留痕；实际办理节点缺人时不能提交。
                              </div>
                              <div v-else>
                                1. 膜组件、膜元件审批流程<br>
                                发起人→（销售助理、商务助理）→部门负责人→技术负责人→财务总监→销售总监→总经理→财务用印<br>
                                2. 一体化审批流程<br>
                                发起人→（销售助理、商务助理）→部门负责人→（技术负责人、交付负责人、运维负责人并行审批）→财务总监→销售总监→总经理→财务用印<br>
                              </div>
                              <el-button slot="reference" type="text">查看流程说明</el-button>
                            </el-popover>
                          </div>
                        </el-form-item>
                      </el-col>
                    </el-row>
                    <el-row>
                      <el-col :xs="24" :md="12" :lg="12">
                        <el-form-item label="商机:" prop="businessId">
                          <el-select v-if="editModel" v-model="updateData.businessId" placeholder="请选择商机" filterable style="width:100%">
                            <el-option v-for="dict in businessList" :key="dict.businessId" :label="dict.businessName" :value="dict.businessId"/>
                          </el-select>
                          <el-link v-else type="primary" class="crm-link-wrap" :underline="false" @click="toBusinessDetail()">{{detail.businessName}}</el-link>
                        </el-form-item>
                      </el-col>
                      <el-col :xs="24" :md="12" :lg="12">
                        <el-form-item label="合同类型:" prop="contractType">
                          <el-select v-if="editModel" v-model="updateData.contractType" placeholder="请选择合同类型" clearable style="width:100%" @change="handleContractTypeChange">
                            <el-option v-for="dict in typeOptions" :key="dict.dictValue" :label="dict.dictLabel" :value="dict.dictValue"/>
                          </el-select>
                          <span v-else class="value">{{detail.contractTypeDesc}}</span>
                        </el-form-item>
                      </el-col>
                    </el-row>
                    <el-row v-if="editModel ? isRentalContractType(updateData.contractType) : isRentalContractType(detail.contractType)">
                      <el-col :xs="24" :md="12" :lg="12">
                        <el-form-item label="租赁到期时间:" prop="contractEndDate" :required="editModel">
                          <el-date-picker v-if="editModel" v-model="updateData.contractEndDate" value-format="yyyy-MM-dd" type="date" placeholder="选择租赁到期时间" style="width:100%"></el-date-picker>
                          <span v-else class="value">{{detail.contractEndDate || '-'}}</span>
                        </el-form-item>
                      </el-col>
                    </el-row>
                    <el-row>
                      <el-col :xs="24" :md="12" :lg="12">
                        <el-form-item label="合同状态:">
                          <span class="value">{{detail.contractStatusDesc}}</span>
                        </el-form-item>
                      </el-col>
                      <el-col :xs="24" :md="12" :lg="12">
                        <el-form-item label="签约客户:" prop="customerId">
                          <customer-select v-if="editModel" ref="customerSelectRef" :form-param="updateData" :param-list="customerList"></customer-select>
                          <el-link v-else type="primary" class="crm-link-wrap" :underline="false" @click="toCustomerDetail()">{{detail.customerName}}</el-link>
                        </el-form-item>
                      </el-col>
                    </el-row>
                    <el-row>
                      <el-col :xs="24" :md="12" :lg="12">
                        <el-form-item label="客户性质:">
                          <span class="value">{{detail.customerNatureDesc}}</span>
                        </el-form-item>
                      </el-col>
                      <el-col :xs="24" :md="12" :lg="12">
                        <el-form-item label="客户类型:">
                          <span class="value">{{detail.customerTypeDesc}}</span>
                        </el-form-item>
                      </el-col>
                    </el-row>
                    <el-row>
                      <el-col :xs="24" :md="12" :lg="12">
                        <el-form-item label="客户级别:">
                          <span class="value">{{detail.customerLevelDesc}}</span>
                        </el-form-item>
                      </el-col>
                      <el-col :xs="24" :md="12" :lg="12">
                        <el-form-item label="总金额:">
                          <span  class="value">{{amountFormat(detail.contractAmount)}}元</span>
                        </el-form-item>
                      </el-col>
                    </el-row>
                    <el-row>
                      <el-col :xs="24" :md="12" :lg="12">
                        <el-form-item label="是否含膜:">
                          <el-checkbox v-if="editModel" v-model="updateData.hasMembrane" @change="handleHasMembraneChange">含膜</el-checkbox>
                          <span v-else class="value">{{detail.hasMembrane || Number(detail.membraneArea) > 0 ? '是' : '否'}}</span>
                        </el-form-item>
                        <el-form-item v-if="editModel ? updateData.hasMembrane : (detail.hasMembrane || Number(detail.membraneArea) > 0)" label="膜面积:" prop="membraneArea">
                          <el-input-number
                            v-if="editModel"
                            v-model="updateData.membraneArea"
                            :min="0"
                            :max="99999999999999"
                            :precision="2"
                            :controls="false"
                            placeholder="请输入膜面积"
                            class="crm-input-number-wrap"
                          />
                          <span v-else class="value">{{detail.membraneArea === null || detail.membraneArea === undefined ? '-' : detail.membraneArea + '㎡'}}</span>
                        </el-form-item>
                      </el-col>
                      <el-col :xs="24" :md="12" :lg="12">
                        <el-form-item label="质保期限(年):" prop="warrantyPeriod">
                          <el-input
                            v-if="editModel"
                            type="number"
                            :maxlength="100"
                            show-word-limit
                            v-model="updateData.warrantyPeriod"
                            placeholder="请输入质保期限"
                            clearable/>
                          <span v-else class="value">{{detail.warrantyPeriod}}</span>
                        </el-form-item>
                      </el-col>
                    </el-row>
                    <el-row>
                      <el-col :xs="24" :md="12" :lg="12">
                        <el-form-item label="质保说明:" prop="warrantyDesc">
                          <el-input
                            v-if="editModel"
                            :maxlength="100"
                            show-word-limit
                            v-model="updateData.warrantyDesc"
                            placeholder="请输入质保说明"
                            clearable/>
                          <span v-else class="value">{{detail.warrantyDesc}}</span>
                        </el-form-item>
                      </el-col>
                    </el-row>
                    <el-row>
                      <el-col :xs="24" :md="12" :lg="12">
                        <el-form-item label="已回款:">
                          <span class="value">{{amountFormat(detail.fundedAmount)}}元</span>
                        </el-form-item>
                      </el-col>
                      <el-col :xs="24" :md="12" :lg="12">
                        <el-form-item label="回款进度:">
                          <span class="value">{{detail.fundProcess}}%</span>
                        </el-form-item>
                      </el-col>
                    </el-row>
                    <el-row>
                      <el-col :xs="24" :md="12" :lg="12" v-if="!editModel">
                        <el-form-item label="创建人:">
                          <span class="value">{{detail.createUserName}}</span>
                        </el-form-item>
                      </el-col>
                      <el-col :xs="24" :md="12" :lg="12" v-if="!editModel">
                        <el-form-item label="创建时间:">
                          <span class="value">{{detail.createTime}}</span>
                        </el-form-item>
                      </el-col>
                    </el-row>
                  <el-row>
                    <el-col :xs="24">
                      <el-col :span="24">
                        <el-form-item label="电子合同:" prop="elContractFileObjs">
                          <FileUpload v-if="editModel"  v-model="updateData.elContractFileObjs" :limit="5" :readOnly="false" @on-change="handleElContractFileChange"></FileUpload>
                          <FileUpload v-else v-model="detail.elContractFileObjs" :limit="5" :readOnly="true"></FileUpload>
                        </el-form-item>
                      </el-col>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :xs="24">
                      <el-form-item label="备注:" prop="remark">
                        <el-input
                          v-if="editModel"
                          type="textarea"
                          :autosize="{ minRows: 3, maxRows: 5}"
                          :maxlength="1000"
                          show-word-limit
                          v-model="updateData.remark"
                          placeholder="请输入备注"
                          clearable/>
                        <span v-else class="value">{{detail.remark}}</span>
                      </el-form-item>
                    </el-col>
                  </el-row>
                </el-row>
                <el-row class="card-item">
                  <p class="card-title">收货信息</p>
                    <el-row>
                      <el-col :xs="24" :md="12" :lg="12">
                        <el-form-item label="收货人:">
                          <el-input v-if="editModel" v-model="updateData.receiverName" :maxlength="32" placeholder="请输入收货人" clearable/>
                          <span v-else class="value" @click="skipCustomerDetail(detail.receiverName)">{{detail.receiverName}}</span>
                        </el-form-item>
                      </el-col>
                      <el-col :xs="24" :md="12" :lg="12">
                        <el-form-item label="联系电话:" prop="receiverMobile">
                          <el-input v-if="editModel" v-model="updateData.receiverMobile" :maxlength="32" placeholder="请输入联系电话" clearable/>
                          <span v-else class="value">{{detail.receiverMobile}}</span>
                        </el-form-item>
                      </el-col>
                      <el-col :xs="24" :md="12" :lg="12">
                        <el-form-item label="业主:" prop="ownerCustomerId">
                          <el-select v-if="editModel" v-model="updateData.ownerCustomerId" placeholder="请选择业主" clearable style="width:100%">
                            <el-option v-for="dict in customerFilterList" :key="dict.id" :label="dict.customerName" :value="dict.id"/>
                          </el-select>
                          <el-link v-else type="primary" class="crm-link-wrap" :underline="false" @click="toCustomerDetail('ownerCustomer')">{{detail.ownerCustomerName}}</el-link>
                        </el-form-item>
                      </el-col>
                      <el-col :xs="24" :md="12" :lg="12">
                        <el-form-item label="项目区域:" prop="area">
                          <el-cascader v-if="editModel" v-model="updateData.area" :options="areaOptions" :props="{ checkStrictly: true }" filterable clearable style="width:100%"></el-cascader>
                          <span v-else class="value">{{detail.areaName}}</span>
                        </el-form-item>
                      </el-col>
                    </el-row>
                    <el-row>
                      <el-col :xs="24" :md="12" :lg="12">
                        <el-form-item label="项目地址:" prop="address">
                          <el-input v-if="editModel" v-model="updateData.address" :maxlength="100" placeholder="请输入项目地址" clearable/>
                          <span v-else class="value">{{detail.address}}</span>
                        </el-form-item>
                      </el-col>
                    </el-row>
                </el-row>
                <el-row class="card-item">
                  <p class="card-title">合同构成</p>
                  <el-button v-if="editModel" type="text" @click="handleAdd('contract')">+新增</el-button>
                  <div v-if="!editModel" class="text-style">产品合计：{{detail.totalCompositionAmount}} 元</div>
                  <div v-if="!editModel" class="text-style">优惠金额：{{detail.discountAmount}} 元</div>
                  <div v-if="!editModel" class="text-style">优惠说明：{{detail.discountDesc}}</div>
                  <div v-if="!editModel" class="text-style">总金额：{{detail.contractAmount}} 元</div>
                  <el-table v-if="!editModel" ref="contractWatch" :data="detail.contractCompositionList">
                    <el-table-column min-width="100" label="产品类型" align="center" prop="productType" />
                    <el-table-column label="商品编码" width="160" align="center" prop="productCode" show-overflow-tooltip>
                      <template slot-scope="scope">
                        {{ scope.row.productCode || '-' }}
                      </template>
                    </el-table-column>
                    <el-table-column label="商品名称" min-width="160" align="center" prop="productName" show-overflow-tooltip>
                      <template slot-scope="scope">
                        {{ scope.row.productName || '-' }}
                      </template>
                    </el-table-column>
                    <el-table-column label="产品型号" width="120" align="center" prop="productModel" >
                      <template slot-scope="scope">
                        {{scope.row.productModel}}
                      </template>
                    </el-table-column>
                    <el-table-column label="合同用量" width="120" align="center">
                      <template slot-scope="scope">
                        {{scope.row.contractUsage + scope.row.usageUnit}}
                      </template>
                    </el-table-column>
                    <el-table-column label="金额（元）" width="120" align="center" prop="amount" />
                    <el-table-column label="单价（元）" width="120" align="center" prop="singlePrice" />
                    <el-table-column label="毛利率" width="100" align="center">
                      <template slot-scope="scope">
                        {{ scope.row.grossMargin == null ? '-' : scope.row.grossMargin + '%' }}
                      </template>
                    </el-table-column>
                    <el-table-column label="备注" min-width="200" align="center" prop="remark">
                      <template slot-scope="scope">
                        {{scope.row.remark}}
                      </template>
                    </el-table-column>
                  </el-table>
                  <el-table v-else ref="contract" :data="updateData.contractCompositionList">
                    <el-table-column min-width="100" align="center">
                      <template slot="header">
                        <span class="red-text">*</span>产品类型
                      </template>
                      <template slot-scope="scope">
                        <el-select v-model="scope.row.productType" placeholder="请选择" clearable style="width:100%">
                          <el-option v-for="dict in productTypeList" :key="dict.value" :label="dict.label" :value="dict.value"/>
                        </el-select>
                      </template>
                    </el-table-column>
                    <el-table-column label="产品型号" min-width="100" align="center">
                      <template slot="header">
                        产品型号
                        <el-popover ref="popover" placement="right" width="450" trigger="hover">
                          <div>
                            1、膜元件：请输入RGE-参数，例RGE-100<br>
                            2、膜组件：请输入RGE-参数-片数，如RGE-100-100片<br>
                            3、一体化和小试装备：请输入每天用吨数<br>
                            4、配套设备/膜配件/技术服务/运维服务：自填<br>
                          </div>
                        </el-popover>
                        <el-button v-popover:popover type="text" class="el-icon-info"></el-button>
                      </template>
                      <template slot-scope="scope">
<!--                        <el-select v-model="scope.row.productModel" placeholder="请选择" allow-create filterable clearable style="width:100%">-->
<!--                          <el-option v-for="dict in scope.row.productModelList" :key="dict.value" :label="dict.label" :value="dict.value"/>-->
<!--                        </el-select>-->
                        <el-input v-model="scope.row.productModel" type="text" :maxlength="50" placeholder="请输入"/>
                      </template>
                    </el-table-column>
                    <el-table-column label="合同用量" width="100" align="center">
                      <template slot="header">
                        <span class="red-text">*</span>合同用量
                      </template>
                      <template slot-scope="scope">
                        <el-input v-model="scope.row.contractUsage" type="number" :maxlength="32" placeholder="请输入合同用量"/>
                      </template>
                    </el-table-column>
                    <el-table-column label="用量单位" min-width="100" align="center">
                      <template slot="header">
                        <span class="red-text">*</span>用量单位
                      </template>
                      <template slot-scope="scope">
                        <el-select v-model="scope.row.usageUnit" placeholder="请选择" clearable style="width:100%">
                          <el-option v-for="dict in usageUnitList" :key="dict.dictValue" :label="dict.dictLabel" :value="dict.dictValue"/>
                        </el-select>
                      </template>
                    </el-table-column>
                    <el-table-column label="金额" min-width="120" align="center">
                      <template slot="header">
                        <span class="red-text">*</span>金额（元）
                      </template>
                      <template slot-scope="scope">
                        <el-input v-model="scope.row.amount" type="number" :maxlength="32" placeholder="请输入金额" clearable/>
                      </template>
                    </el-table-column>
                    <el-table-column label="备注" min-width="100" align="center">
                      <template slot-scope="scope">
                        <el-input v-model="scope.row.remark" type="text" :maxlength="32" placeholder="请输入备注"/>
                      </template>
                    </el-table-column>
                    <el-table-column label="操作" width="100" align="center" fixed="right" class-name="small-padding fixed-width">
                      <template slot-scope="scope">
                        <el-button v-show="updateData.contractCompositionList.length > 1" type="text"  @click="handleDelete('contract', scope)">删除</el-button>
                      </template>
                    </el-table-column>
                  </el-table>
                  <br>
                  <el-form-item v-if="editModel" label="优惠金额(元)：" prop="discountAmount">
                    <el-input v-model="updateData.discountAmount" placeholder="请输入优惠金额" clearable/>
                  </el-form-item>
                  <el-form-item v-if="editModel" label="优惠说明：" prop="discountDesc">
                    <el-input v-model="updateData.discountDesc" type="textarea" :maxlength="500" show-word-limit placeholder="请输入优惠说明" clearable/>
                  </el-form-item>
                  <el-form-item v-if="editModel" label="总金额：">
                    {{totalAmount}}元
                  </el-form-item>
                </el-row>
                <el-row class="card-item">
                  <p class="card-title">签约信息</p>
                  <el-col :span="24">
                    <el-form-item label="签约日期:" prop="contractSignDate">
                      <el-date-picker v-if="editModel" v-model="updateData.contractSignDate" value-format="yyyy-MM-dd" type="date" placeholder="选择日期" style="width:100%"></el-date-picker>
                      <span v-else class="value">{{detail.contractSignDate}}</span>
                    </el-form-item>
                  </el-col>
                  <el-col :span="24">
                    <el-form-item label="签约文件:" prop="fileObjs">
                      <FileUpload v-if="editModel"  v-model="updateData.fileObjs" :limit="5" :readOnly="false" @on-change="handleFileChange"></FileUpload>
                      <FileUpload v-else v-model="detail.fileUrls" :limit="5" :readOnly="true"></FileUpload>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row class="card-item">
                  <p class="card-title">发货信息</p>
                  <ExpressList :contract-id="detail.id" :editAble="false"/>
                </el-row>
              </el-form>
            </el-tab-pane>
            <el-tab-pane label="审批信息" name="check">
              <el-row class="card-item">
                <p class="card-title">基本信息</p>
                <el-form ref="baseInfo" label-width="110px" :hide-required-asterisk="!editModel">
                  <el-row :gutter="20" align="left">
                    <el-col :xs="24" :md="12" :lg="12">
                      <el-form-item label="合同编号:" prop="contractNum">
                        <span class="value">{{detail.contractNum}}</span>
                      </el-form-item>
                    </el-col>
                    <el-col :xs="24" :md="12" :lg="12">
                      <el-form-item label="签约客户:" prop="customerId">
                        <el-link type="primary" class="crm-link-wrap" :underline="false" @click="toCustomerDetail()">{{detail.customerName}}</el-link>
                      </el-form-item>
                    </el-col>
                    <el-col :xs="24" :md="12" :lg="12">
                      <el-form-item label="商机:" prop="businessId">
                        <el-link  type="primary" class="crm-link-wrap" :underline="false" @click="toBusinessDetail()">{{detail.businessName}}</el-link>
                      </el-form-item>
                    </el-col>
                    <el-col :xs="24" :md="12" :lg="12">
                      <el-form-item label="总金额:">
                        <span  class="value">{{amountFormat(detail.contractAmount)}}元</span>
                      </el-form-item>
                    </el-col>
                    <el-col :xs="24" :md="24" :lg="24">
                      <el-form-item label="商机阶段:">
                        <span class="value">{{detail.businessCurrentStageDesc}}</span>
                      </el-form-item>
                    </el-col>
                  </el-row>
                </el-form>
              </el-row>
              <el-row class="card-item">
                <p class="card-title">审批记录</p>
                <el-popover placement="left" width="700" trigger="click" class="approvelDesc">
                  <div>
                    请各角色核实、完成指定工作<br>
                    发起人：填写合同基本信息、选择商机、上传电子版合同、填写合同价格构成，确定合同相关的客户、合同、联系人有跟进记录；<br>
                    销售助理：核实电子合同模板，合同信息录入完整性；<br>
                    销售经理：确认合同的付款方式、价格构成、开票时间、质保期等相关信息，如有异常做出说明；<br>
                    技术、交付、运维负责人：确认合同的产品参数、技术成本、实时范围、运维范围等信息，对异常做出说明；<br>
                    财务总监：审核合同金额，排查合同的税务风险；<br>
                    销售总监：确认合同的价格构成、差异信息、综合信息，对异常做出说明；<br>
                    总经理：综合风险控制；<br>
                    销售助理：打印合同；<br>
                    行政人事：合同盖章；<br>
                    销售助理：双向盖章合同电子版上传；<br>
                    财务部：纸质合同归档。<br>
                  </div>
                  <el-button slot="reference" type="text">审批说明</el-button>
                </el-popover>
                <approveInfo ref="approveInfo"  @success="refreshDetailAndLog" :targetId="detail.workOrderId" targetType="contract"></approveInfo>
              </el-row>
            </el-tab-pane>
            <el-tab-pane label="关联事项" name="relatedMatters" lazy>
              <ContractRelatedMatters :contract-id="detail.id" @open-tab="switchFinanceTarget" />
            </el-tab-pane>
            <el-tab-pane :label="'开票记录(' + contractInvoiceCount + ')'" name="contractInvoice">
              <InvoiceList ref="invoiceListRef" :contractId="detail.id" height="630" @after-query="handleAfterInvoiceQuery"></InvoiceList>
            </el-tab-pane>
            <el-tab-pane :label="'交付(' + deliverCount + ')'" name="deliver">
              <DeliverList ref="deliverListRef" :contractStatus="detail.contractStatus" :contractId="detail.id" :customerId="detail.customerId" height="630" @after-query="handleAfterDeliverQuery">
              </DeliverList>
            </el-tab-pane>
            <el-tab-pane label="履约采购" name="fulfillment" style="padding:10px">
              <div v-loading="fulfillmentLoading">
                <el-alert
                  title="履约采购用于承接合同签约后的内部采购底稿。客户合同只体现销售清单和交付范围；技术提供的采购Excel、采购需求明细和确认金额在这里维护，用于后续采购执行和项目利润核算。"
                  type="info"
                  :closable="false"
                  show-icon
                  class="fulfillment-alert"/>
                <div v-if="!fulfillmentProject || !fulfillmentProject.id" class="fulfillment-empty">
                  <div class="fulfillment-empty-title">当前合同还没有履约项目</div>
                  <div class="fulfillment-empty-desc">可以按合同商品和交付与成本构成自动生成采购需求底稿，也可以先创建空履约项目后人工维护采购需求。</div>
                  <el-button type="primary" @click="handleAutoCreateFulfillment">按合同商品生成</el-button>
                  <el-button @click="handleManualCreateFulfillment">手动创建履约项目</el-button>
                </div>
                <template v-else>
                  <el-row :gutter="16" class="fulfillment-summary">
                    <el-col :xs="24" :md="6">
                      <div class="fulfillment-stat">
                        <div class="fulfillment-stat-label">履约项目编号</div>
                        <div class="fulfillment-stat-value">{{ fulfillmentProject.projectNo || '-' }}</div>
                      </div>
                    </el-col>
                    <el-col :xs="24" :md="6">
                      <div class="fulfillment-stat">
                        <div class="fulfillment-stat-label">来源</div>
                        <div class="fulfillment-stat-value">{{ sourceModeText(fulfillmentProject.sourceMode) }}</div>
                      </div>
                    </el-col>
                    <el-col :xs="24" :md="6">
                      <div class="fulfillment-stat">
                        <div class="fulfillment-stat-label">预计采购成本</div>
                        <div class="fulfillment-stat-value">{{ amountFormat(fulfillmentProject.expectedCostAmount || 0) }}</div>
                      </div>
                    </el-col>
                    <el-col :xs="24" :md="6">
                      <div class="fulfillment-stat">
                        <div class="fulfillment-stat-label">采购状态</div>
                        <div class="fulfillment-stat-value">{{ procurementStatusText(fulfillmentProject.procurementStatus) }}</div>
                      </div>
                    </el-col>
                  </el-row>
                  <el-row class="row-margin" type="flex" justify="space-between" align="middle">
                    <div class="fulfillment-project-name">{{ fulfillmentProject.projectName }}</div>
                    <div>
                      <el-button icon="el-icon-refresh" @click="queryFulfillmentProject">刷新</el-button>
                      <el-button type="primary" icon="el-icon-plus" @click="openRequirementDialog(null, 'add')">新增采购需求</el-button>
                    </div>
                  </el-row>
                  <div class="procurement-file-section">
                    <div class="procurement-file-header">
                      <div>
                        <div class="procurement-file-title">技术采购单附件</div>
                        <div class="muted-text">上传技术提供的采购Excel或相关文件，作为后续采购需求确认和采购执行依据。</div>
                      </div>
                      <el-button type="primary" size="mini" :loading="procurementFileSaving" @click="handleSaveProcurementFiles">保存附件</el-button>
                    </div>
                    <FileUpload
                      v-model="fulfillmentProject.procurementFileObjs"
                      :limit="5"
                      :multiple="true"
                      :readOnly="false"
                      accept=".xls,.xlsx,.pdf,.doc,.docx"
                      @on-change="handleProcurementFileChange">
                    </FileUpload>
                  </div>
                  <el-table :data="fulfillmentProject.requirementList || []" border class="row-margin">
                    <el-table-column label="来源商品" min-width="170" show-overflow-tooltip>
                      <template slot-scope="scope">
                        <div>{{ scope.row.productName || '-' }}</div>
                        <div class="muted-text">{{ scope.row.productCode || scope.row.productModel || '-' }}</div>
                      </template>
                    </el-table-column>
                    <el-table-column label="需求名称" min-width="160" prop="requirementName" show-overflow-tooltip/>
                    <el-table-column label="类型" width="80" align="center">
                      <template slot-scope="scope">{{ itemTypeText(scope.row.itemType) }}</template>
                    </el-table-column>
                    <el-table-column label="供应方式" width="110" align="center" prop="supplyMode" show-overflow-tooltip/>
                    <el-table-column label="需求数量" width="110" align="right">
                      <template slot-scope="scope">{{ scope.row.requirementQuantity || 0 }}{{ scope.row.unit || '' }}</template>
                    </el-table-column>
                    <el-table-column label="标准成本" width="110" align="right">
                      <template slot-scope="scope">{{ amountFormat(scope.row.standardUnitCost || 0) }}</template>
                    </el-table-column>
                    <el-table-column label="预计金额" width="110" align="right">
                      <template slot-scope="scope">{{ amountFormat(scope.row.estimatedAmount || 0) }}</template>
                    </el-table-column>
                    <el-table-column label="供应商" width="140" prop="supplierName" show-overflow-tooltip/>
                    <el-table-column label="确认金额" width="110" align="right">
                      <template slot-scope="scope">{{ amountFormat(scope.row.confirmedAmount || 0) }}</template>
                    </el-table-column>
                    <el-table-column label="状态" width="100" align="center">
                      <template slot-scope="scope">
                        <el-tag size="mini" :type="requirementStatusType(scope.row.confirmStatus)">
                          {{ requirementStatusText(scope.row.confirmStatus) }}
                        </el-tag>
                      </template>
                    </el-table-column>
                    <el-table-column label="提示" min-width="140" show-overflow-tooltip>
                      <template slot-scope="scope">
                        <span :class="requirementRiskText(scope.row) === '正常' ? 'muted-text' : 'warning-text'">{{ requirementRiskText(scope.row) }}</span>
                      </template>
                    </el-table-column>
                    <el-table-column label="操作" width="210" align="center" fixed="right">
                      <template slot-scope="scope">
                        <el-button type="text" :disabled="!canEditRequirement(scope.row)" @click="openRequirementDialog(scope.row, 'edit')">编辑</el-button>
                        <el-button type="text" :disabled="!canConfirmRequirement(scope.row)" @click="openRequirementDialog(scope.row, 'confirm')">确认</el-button>
                        <el-button type="text" :disabled="!canTransferRequirement(scope.row)" @click="handleTransferRequirement(scope.row)">转采购</el-button>
                        <el-button type="text" class="danger-text" :disabled="!canCancelRequirement(scope.row)" @click="handleCancelRequirement(scope.row)">作废</el-button>
                      </template>
                    </el-table-column>
                  </el-table>
                </template>
              </div>
            </el-tab-pane>
            <el-tab-pane label="项目成本" name="cost" style="padding:10px">
              <el-row :gutter="20">
                <el-col :xs="24" :md="8" :lg="8">
                  <div class="amountContainer">
                    <div>项目总金额（元）</div>
                    <div>{{amountFormat(detail.contractAmount)}}</div>
                  </div>
                </el-col>
                <el-col :xs="24" :md="8" :lg="8">
                  <div class="amountContainer">
                    <div>已花费金额（元）</div>
                    <div>{{amountFormat(sumCostAmount)}}</div>
                  </div>
                </el-col>
                <el-col :xs="24" :md="8" :lg="8">
                  <div class="amountContainer">
                    <div>项目实际收入（元）</div>
                    <div>{{amountFormat(detail.contractAmount - sumCostAmount)}}</div>
                  </div>
                </el-col>
              </el-row>
              <el-row :gutter="20" class="row-margin">
                <el-button type="primary" @click="showAddCostForm(null)">新增成本</el-button>
              </el-row>
              <el-row :gutter="20" class="row-margin">
                <el-table :data="costList">
                  <el-table-column label="成本类型" align="center" prop="costAmount">
                    <template slot-scope="scope">
                      <span v-if="scope.row.costType === 1">人工成本</span>
                      <span v-else-if="scope.row.costType === 2">材料</span>
                      <span v-else-if="scope.row.costType === 3">合伙人成本</span>
                      <span v-else-if="scope.row.costType === 4">项目费用</span>
                    </template>
                  </el-table-column>
                  <el-table-column label="金额（元）" align="center" prop="costAmount">
                    <template slot-scope="scope">
                      <span>{{amountFormat(scope.row.costAmount)}}</span>
                    </template>
                  </el-table-column>
                  <el-table-column label="创建人" align="center" prop="createNickName"></el-table-column>
                  <el-table-column label="备注"  align="center" prop="remark" show-overflow-tooltip width="120"></el-table-column>
                  <el-table-column label="来源" align="center" prop="source">
                    <template slot-scope="scope">
                      <span v-if="scope.row.source === 1">钉钉报销</span>
                      <span v-else-if="scope.row.source === 3">系统报销</span>
                      <span v-else-if="scope.row.source === 2">人工录入</span>
                    </template>
                  </el-table-column>
                  <el-table-column label="更新时间" align="center" prop="updateTime"></el-table-column>
                  <el-table-column label="操作" width="100" fixed="right" :show-overflow-tooltip="true" align="center" >
                    <template slot-scope="scope">
                        <span v-if="scope.row.source === 1 || scope.row.source === 3"> / </span>
                        <el-button type="text" v-if="scope.row.source === 2" @click="showAddCostForm(scope.row)">编辑</el-button>
                        <el-button type="text" v-if="scope.row.source === 2" @click="handleCostDelete(scope.row)">删除</el-button>
                    </template>
                  </el-table-column>
                </el-table>
                <pagination v-if="costTotal" :total="costTotal" :page.sync="costQueryParams.pageNum" :limit.sync="costQueryParams.pageSize" @pagination="queryCostList"/>
              </el-row>
              <el-dialog :title="costFormTitle === 1?'新增':'编辑'" :visible.sync="addCostFormVisible" :close-on-click-modal="false" :close-on-press-escape="false" width="30%">
                <el-form :model="costData" :rules="updateCostRules" ref="addCostForm" label-width="120px">
                  <el-form-item label="成本类型：" prop="costType">
                    <el-select ref="costTypeSelectRef" v-model="costData.costType" clearable filterable placeholder="请选择成本类型" style="width: 100%">
                      <el-option v-for="item in costTypes"
                                :key="item.id" :label="item.name" :value="item.id"/>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="金额（元）:" prop="costAmount">
                    <el-input v-model="costData.costAmount" style="width: 200px" type="number" :maxlength="30" placeholder="请输入金额" clearable/>
                  </el-form-item>
                  <el-form-item label="备注:" prop="remark">
                    <el-input type="textarea" :autosize="{ minRows: 5, maxRows: 10}" :maxlength="200" show-word-limit v-model="costData.remark" placeholder="请输入200字以内" clearable/>
                  </el-form-item>
                </el-form>
                <span slot="footer" class="dialog-footer">
                  <el-button @click="closeAddCostForm">取消</el-button>
                  <el-button type="primary" @click="handleCost">确认</el-button>
                </span>
              </el-dialog>
            </el-tab-pane>
            <el-tab-pane label="交付计划">
              <ContractPhase :contractId="detail.id" :phaseRemark.sync="detail.phaseRemark"/>
            </el-tab-pane>
          </el-tabs>
        </el-card>
      </el-col>
      <el-col :span="sidebarCollapsed ? 0 : 8" v-show="!sidebarCollapsed">
        <el-card class="crm-detail-follow" v-if="detail.id" shadow="never">
          <div class="label">负责人</div>
          <div class="crm-manager">
            <UserAvatar class="avatar" :url="detail.assignUserAvatar" :name="detail.assignUserName"/>
            <div class="name"><span class="value">{{detail.assignUserName}}</span></div>
          </div>
          <GroupMember :groupName="'合同团队'" :targetId="detail.id" :targetType="'contract'"
                       :canAddGroupMemberFlag="detail.canAddGroupMemberFlag" @success="handleGroupMemberSuccess"/>
          <el-divider content-position="left"><span class="label">操作日志</span></el-divider>
          <div style="height: 534px">
            <OperateLogList ref="operateLogListRef" :targetId="detail.id" targetType="contract"></OperateLogList>
          </div>
        </el-card>
      </el-col>
    </el-row>
    <AssignDialog ref="assignDialogRef" @success="refreshDetailAndLog"></AssignDialog>
    <el-dialog :title="requirementDialogTitle" :visible.sync="requirementDialogVisible" :close-on-click-modal="false" width="760px">
      <el-form ref="requirementForm" :model="requirementForm" :rules="requirementRules" label-width="110px">
        <el-row :gutter="16">
          <el-col :xs="24" :md="12">
            <el-form-item label="需求名称" prop="requirementName">
              <el-input v-model="requirementForm.requirementName" :disabled="requirementDialogMode === 'confirm'" maxlength="128" placeholder="例如：RGE-100膜片、支架、安装服务"/>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :md="12">
            <el-form-item label="类型">
              <el-select v-model="requirementForm.itemType" :disabled="requirementDialogMode === 'confirm'" placeholder="请选择" style="width:100%">
                <el-option v-for="item in requirementItemTypeOptions" :key="item.value" :label="item.label" :value="item.value"/>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :md="12">
            <el-form-item label="供应方式">
              <el-input v-model="requirementForm.supplyMode" :disabled="requirementDialogMode === 'confirm'" maxlength="64" placeholder="采购、外协、自制、待确认"/>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :md="12">
            <el-form-item label="需求数量" prop="requirementQuantity">
              <el-input v-model="requirementForm.requirementQuantity" :disabled="requirementDialogMode === 'confirm'" type="number" placeholder="请输入数量"/>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :md="12">
            <el-form-item label="单位">
              <el-input v-model="requirementForm.unit" :disabled="requirementDialogMode === 'confirm'" maxlength="32" placeholder="片、套、个、项"/>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :md="12">
            <el-form-item label="标准成本">
              <el-input v-model="requirementForm.standardUnitCost" :disabled="requirementDialogMode === 'confirm'" type="number" placeholder="用于预计成本测算"/>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :md="12">
            <el-form-item label="预计金额">
              <el-input v-model="requirementForm.estimatedAmount" :disabled="requirementDialogMode === 'confirm'" type="number" placeholder="为空时按数量*标准成本计算"/>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :md="12">
            <el-form-item label="供应商">
              <el-input v-model="requirementForm.supplierName" maxlength="128" placeholder="确认采购前可先留空"/>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :md="12">
            <el-form-item label="确认单价">
              <el-input v-model="requirementForm.confirmedUnitPrice" type="number" placeholder="采购确认价"/>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :md="12">
            <el-form-item label="确认金额">
              <el-input v-model="requirementForm.confirmedAmount" type="number" placeholder="为空时按数量*确认单价计算"/>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :md="12">
            <el-form-item label="预计到货">
              <el-date-picker v-model="requirementForm.expectArrivalDate" value-format="yyyy-MM-dd" type="date" placeholder="选择日期" style="width:100%"/>
            </el-form-item>
          </el-col>
          <el-col :xs="24">
            <el-form-item label="备注">
              <el-input v-model="requirementForm.remark" type="textarea" :rows="3" maxlength="500" show-word-limit placeholder="记录采购确认说明、非标原因或作废原因"/>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="requirementDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="submitRequirement">确认</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import FollowList from "@/views/crm/follow/followList";
import FollowAdd from "@/views/crm/follow/followAdd";
import WorkPlan from "@/views/crm/workPlan/workPlan";
import OperateLogList from "@/views/crm/components/operateLogList";
import DeliverList from "@/views/crm/delivery/deliverList";
import approveInfo from "@/views/crm/components/approveInfo";
import AssignDialog from "@/views/crm/components/assignDialog";
import ConfirmCheck from "@/views/crm/components/confirmCheck";
import EndDialog from "@/views/crm/components/endDialog";
import ConfirmContract from "@/views/crm/components/confirmContract";
import FinanceConfirm from "@/views/crm/components/financeConfirm";
import ContractArchive from "@/views/crm/components/contractArchive";
import UserAvatar from '@/views/system/user/userAvatar'
import FileUpload from "@/views/crm/components/fileUpload";
import UserSelect from "@/views/crm/components/userSelect";
import InvoiceList from "@/views/crm/invoice/invoiceList";
import {queryContactByCustomerId} from "@/api/crm/contact";
import {
  createApproval,
  handleWorkOrder,
  queryContractDetail,
  queryContractFinanceOverview,
  queryProductTypeList,
  updateContract,
  queryCostList,
  addCost,
  updateCost,
  removeCost,
  retryArchiveRecognition
} from "@/api/crm/contract";
import {amountFormat} from '@/utils/index'
import contractDetailInfo from "@/views/crm/planFund/contractDetail"
import {treeSelectWithOutDataScope} from "@/api/system/dept";
import Treeselect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import {listUserWithOutDataScope} from "@/api/system/user";
import {mapState} from 'vuex'
import { checkPermi } from '@/utils/permission'
import {listSimpleAll} from "@/api/crm/customer";
import {listAllLevelArea} from '@/api/crm/area'
import {querySimpleList} from "@/api/crm/business";
import {transferCascaderOptionsForProvince} from '@/utils'
import {gteZero2, validPhone} from "@/utils/validator";
import customerSelect from "@/views/crm/components/customerSelect";
import ExpressList from "@/views/crm/delivery/expressList"
import GroupMember from "@/views/crm/groupMember"
import ContractPhase from "@/views/crm/phase/contractPhase.vue";
import ContractRelatedMatters from "@/views/crm/contract/ContractRelatedMatters.vue";
import download from "@/plugins/download"
import {
  autoCreateFulfillment,
  cancelProcurementRequirement,
  confirmProcurementRequirement,
  getFulfillmentByContractId,
  manualCreateFulfillment,
  saveProcurementFiles,
  saveProcurementRequirement,
  transferProcurementRequirement
} from "@/api/crm/fulfillmentProject";

export default {
  name: "ContractDetail",
  data() {
    return {
      // 遮罩层
      productTypeList: [],
      usageUnitList: [],
      areaOptions: [],
      customerList: [],
      customerFilterList: [],
      activeName: "followPlan",
      followPlanActiveName: 'follow',
      amountFormat,
      loading: true,
      detail: {},
      editModel: false,
      sidebarCollapsed: false,
      typeOptions: [],
      statusOptions: [],
      businessList: [],
      contactList: [],
      deliverCount: 0,
      contractPlanFundCount: 0,
      contractFundRecordCount: 0,
      contractInvoiceCount: 0,
      cantractData: [],
      costList: [],
      addCostFormVisible: false,
      costFormTitle: 1, //1新增成本 2编辑成本
      costTypes: [
        {id: 1, name: '人工成本'},
        {id: 2, name: '材料'},
        {id: 3, name: '合伙人成本'},
        {id: 4, name: '项目费用'},
      ],
      sumCostAmount: null,
      costTotal: 0,
      fulfillmentLoading: false,
      financeOverviewLoading: false,
      financeOverview: null,
      procurementFileSaving: false,
      fulfillmentProject: null,
      requirementDialogVisible: false,
      requirementDialogMode: 'add',
      requirementForm: {},
      requirementItemTypeOptions: [
        {value: 1, label: '物料'},
        {value: 2, label: '服务'},
        {value: 3, label: '费用'},
        {value: 4, label: '资产'}
      ],
      requirementRules: {
        requirementName: [
          {required: true, message: '请输入需求名称', trigger: 'blur'}
        ],
        requirementQuantity: [
          {required: true, message: '请输入需求数量', trigger: 'blur'}
        ]
      },
      costQueryParams: {
        pageNum: 1,
        pageSize: 10
      },
      costData: {
        id: null,
        targetId: this.$route.params.id,
        targetType: 'contract',
        costType: null,
        costAmount: null,
        source: 2,
        remark: ''
      },
      updateCostRules: {
        costType: [
          {required: true, message: '请选择成本类型', trigger: 'blur'}
        ],
        costAmount: [
          {required: true, message: '请填写成本金额', trigger: 'blur'},
          {
            validator: (rule, value, callback) => {
              // 空值交给前面的 required 校验
              if (value === undefined || value === null || value === '') {
                callback()
                return
              }
              // 1. 必须大于 0
              if (value <= 0) {
                callback(new Error('成本金额必须大于0'))
                return
              }
              // 2. 小数位不能超过 2 位
              const valueStr = value.toString()
              if (valueStr.indexOf('.') !== -1 && valueStr.split('.')[1].length > 2) {
                callback(new Error('成本金额最多保留两位小数'))
                return
              }
              // 校验通过
              callback()
            },
            trigger: 'blur'
          }
        ]
      },
      updateData: {
        id: null,
        customerId: null,
        businessId: null,
        contractAmount: undefined,
        discountAmount: null,
        discountDesc: null,
        contractType: null,
        contractStatus: null,
        contractStartDate: null,
        contractEndDate: null,
        contractNum: null,
        customerSignContactId: null,
        ourSideSignUserId: null,
        contractSignDate: null,
        contractCompositionList: [],
        fileObjs: [],
        remark: null,
        warrantyDesc: null,
        warrantyPeriod: null,
        hasMembrane: false,
        membraneArea: null
      },
      updateRules: {
        receiverName: [
          {required: true, message: '请输入收货人', trigger: 'change'}
        ],
        receiverMobile: [
          {required: false, validator: validPhone, trigger: 'change'}
        ],
        customerId: [
          {required: true, message: '请选择签约客户', trigger: 'change'}
        ],
        discountAmount: [
          {type: 'number', validator: gteZero2, message: '请输入大于等于0的两位小数', trigger: 'change'}
        ],
        contractAmount: [
          {required: true, type:'number', message: '请输入总金额', trigger: 'blur'}
        ],
        contractType: [
          {required: true, message: '请选择合同类型', trigger: 'change'}
        ],
        membraneArea: [
          {type: 'number', validator: gteZero2, message: '请输入大于等于0的两位小数', trigger: 'change'}
        ],
        elContractFileObjs: [
          {required: true, message: '电子合同不能为空', trigger: 'change'}
        ],
        warrantyPeriod: [
          {required: true, message: '请输入质保期限', trigger: 'change'}
        ],
        contractSignDate: [
          {required: true, message: '请选择签约日期', trigger: 'change'}
        ],
      },
    };
  },
  components: {
    ContractRelatedMatters,
    FollowList,
    FollowAdd,
    WorkPlan,
    OperateLogList,
    DeliverList,
    AssignDialog,
    InvoiceList,
    UserAvatar,
    UserSelect,
    FileUpload,
    contractDetailInfo,
    approveInfo,
    Treeselect,
    ConfirmCheck,
    EndDialog,
    ConfirmContract,
    FinanceConfirm,
    ContractArchive,
    customerSelect,
    ExpressList,
    GroupMember,
    ContractPhase
  },
  created() {
    if (this.$route.params.id) {
      this.queryDetail()
    } else {
      this.msgError("无效的合同");
    }
    this.getDicts("contract_type").then(response => {
      this.typeOptions = response.data;
    });
    this.getDicts("contract_status").then(response => {
      this.statusOptions = response.data;
    });
    this.queryProductTypeList()
    listSimpleAll({
      customerNature: 1
    }).then(response => {
      this.customerFilterList = response.data;
    });
    listAllLevelArea({ level: 2 }).then(response => {
      this.areaOptions = transferCascaderOptionsForProvince(response.data);
    });
    this.getDicts("usage_unit").then(response => {
      this.usageUnitList = response.data;
    });
    this.querySimpleList();
    this.queryCostList();
  },
  computed: {
    canViewCollections () {
      return !this.isRjtTenant || checkPermi(['crm:planFund:manage', 'crm:fundRecord:manage', 'crm:fundRecord:detail', 'crm:fundRecord:edit', 'crm:fundRecord:delete'])
    },
    ...mapState({
      currentUserId: state => state.user.userId,
      tenantId: state => state.user.tenantId,
    }),
    isRjtTenant () {
      return String(this.tenantId) === '118'
    },
    totalAmount () {
      let total = 0
      if (this.editModel) {
        total = this.updateData.contractCompositionList.reduce((result, item)=> {
          result += Number(item.amount)
          return result
        }, 0)
        if (this.updateData.discountAmount) {
          total -= Number(this.updateData.discountAmount)
        }
      }
      return total
    },
    requirementDialogTitle () {
      if (this.requirementDialogMode === 'confirm') {
        return '确认采购需求'
      }
      return this.requirementForm && this.requirementForm.id ? '编辑采购需求' : '新增采购需求'
    }
  },
  watch: {
    editModel (val) {
      if (!val) {
        this.resetForm("updateForm");
      }
    },
    'detail.customerId' (val) {
      if (val) {
        queryContactByCustomerId({customerId: val}).then(response => {
          this.contactList = response.data || [];
        });
      }
    }
  },
  methods: {
    clearForm () {
    },
    handleOption (type) {
      switch (type) {
        case 1:
          this.$refs.confirmCheckRef.options(this.detail.id)
          break
        case 2:
          this.$refs.endDialogRef.options(this.detail.id)
          break
        case 3:
          this.$refs.confirmContractRef.options(this.detail.id)
          break
        case 4:
          this.$refs.financeConfirmRef.options(this.detail.id, this.detail.archiveNo, this.isRjtTenant)
          break
        case 5: // 撤回审批
          this.$confirm('确认撤回审批单吗？', '提示', {
            confirmButtonText: '确认',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            const loading = this.$loading({lock: true, text: '加载中', spinner: 'el-icon-loading'});
            handleWorkOrder({
              workOrderId: this.detail.workOrderId,
              operationType: 3 // 1 通过 2 驳回 3 取消
            }).then(response => {
              this.msgSuccess("操作成功");
              this.refreshDetailAndLogAndApprovalRecord()
            }).finally(() => {
              loading.close()
            })
          })
          break
        case 6: // 发起审批
          this.$confirm('确认发起合同审批吗？', '提示', {
            confirmButtonText: '确认',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            const loading = this.$loading({lock: true, text: '加载中', spinner: 'el-icon-loading'});
            createApproval({
              contractId: this.detail.id
            }).then(response => {
              this.msgSuccess("操作成功");
              this.refreshDetailAndLogAndApprovalRecord()
            }).finally(() => {
              loading.close()
            })
          })
          break
      }
    },
    handleArchiveNo () {
      this.$refs.contractArchiveRef.options(this.detail.id, this.detail.archiveNo)
    },
    handleRetryArchiveRecognition () {
      this.$confirm('将优先识别签约文件；没有签约文件时识别合同文件，是否继续？', '提示', {
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => retryArchiveRecognition({ id: this.detail.id })).then(() => {
        this.msgSuccess('已提交后台识别')
        this.queryDetail()
      })
    },
    handleAdd (type) {
      if (type == 'contract') {
        let contractId = this.updateData.id
        this.updateData.contractCompositionList.push({
          "amount": null,
          "contractId": contractId,
          "contractUsage": 1,
          "productModel": null,
          "productType": null,
          "remark": "",
          "usageUnit": null
        })
      }
    },
    handleDelete (type, scope) {
      const {$index, row} = scope
      if (type == 'contract') {
        this.updateData.contractCompositionList.splice($index, 1)
      }
    },
    // 查询产品型号
    // queryProductModelList (row, empty) {
    //   this.$nextTick(() => {
    //     queryProductModelList({
    //       value: row.productType
    //     }).then(response => {
    //       const {code, msg, data} = response
    //       if (code == 200) {
    //         row.productModelList = data || [];
    //         if (empty) {
    //           row.productModel = null
    //         }
    //         if (this.$refs['contract']) {
    //           this.$refs['contract'].tableData.splice(1, 0)
    //         }
    //       }
    //     })
    //   }, 20)
    // },
    // 查询产品类型
    queryProductTypeList () {
      queryProductTypeList({}).then(response => {
        const {code, msg, data} = response
        if (code == 200) {
          this.productTypeList = data || [];
        }
      })
    },
    // 查询项目成本列表
    queryCostList () {
      queryCostList(Object.assign({
        targetId: this.$route.params.id
      },
      this.costQueryParams)).then(response => {
        const {total, otherData, rows, msg, code} = response
        if (code == 200) {
          this.costList = rows || []
          this.costTotal = total
          this.sumCostAmount = otherData
        }
      })
    },
    emptyRequirementForm () {
      return {
        id: null,
        fulfillmentProjectId: this.fulfillmentProject ? this.fulfillmentProject.id : null,
        contractCompositionId: null,
        productId: null,
        productCode: '',
        productName: '',
        productModel: '',
        categoryName: '',
        bomId: null,
        requirementName: '',
        itemType: 1,
        supplyMode: '',
        requirementQuantity: null,
        unit: '',
        standardUnitCost: null,
        estimatedAmount: null,
        supplierName: '',
        confirmedUnitPrice: null,
        confirmedAmount: null,
        expectArrivalDate: null,
        confirmStatus: 10,
        remark: ''
      }
    },
    syncRequirementEstimatedAmount () {
      const quantity = Number(this.requirementForm.requirementQuantity)
      const unitCost = Number(this.requirementForm.standardUnitCost)
      if (quantity > 0 && this.requirementForm.standardUnitCost !== null && this.requirementForm.standardUnitCost !== '' && unitCost >= 0) {
        this.requirementForm.estimatedAmount = (quantity * unitCost).toFixed(2)
      }
    },
    syncRequirementConfirmedAmount () {
      const quantity = Number(this.requirementForm.requirementQuantity)
      const unitPrice = Number(this.requirementForm.confirmedUnitPrice)
      if (quantity > 0 && this.requirementForm.confirmedUnitPrice !== null && this.requirementForm.confirmedUnitPrice !== '' && unitPrice >= 0) {
        this.requirementForm.confirmedAmount = (quantity * unitPrice).toFixed(2)
      }
    },
    showAddCostForm(row) {
      this.addCostFormVisible = true
      this.costFormTitle = 1
      if(row && row.id) {
        this.costData.id = row.id
        this.costData.costType = row.costType
        this.costData.costAmount = row.costAmount
        this.costData.remark = row.remark
        this.costFormTitle = 2
      } else {
        this.costData.id = null
        this.costData.costType = null
        this.costData.costAmount = null
        this.costData.remark = ''
      }
    },

    closeAddCostForm() {
      this.addCostFormVisible = false
    },
    // 新增或项目成本
    handleCost () {
      this.$refs["addCostForm"].validate(valid => {
        if (valid) {
          const loading = this.$loading({lock: true, text: '加载中', spinner: 'el-icon-loading'});
          this.costData.targetId = this.$route.params.id
          if(this.costData.id && this.costData.id > 0) {
            updateCost(this.costData).then(response => {
              this.queryCostList()
              this.msgSuccess("操作成功");
              this.addCostFormVisible = false
            }).finally(() => {
              loading.close()
            })
          } else {
            addCost(this.costData).then(response => {
              this.queryCostList()
              this.msgSuccess("操作成功");
              this.addCostFormVisible = false
            }).finally(() => {
              loading.close()
            })
          }
        }
      })
    },
    // 删除项目成本
    handleCostDelete(row) {
      this.$confirm('删除后将无法恢复，是否确认删除该成本?', "警告", {
          confirmButtonText: "确认",
          cancelButtonText: "取消",
          type: "warning"
      }).then(() => {
          const loading = this.$loading({
              lock: true,
              text: '加载中',
              spinner: 'el-icon-loading'
          });
          removeCost(row.id).then(response => {
              this.$message.success('成本删除成功')
              this.queryCostList();
              loading.close();
          }).catch(error => {
              loading.close();
          });

      })
    },

    /**
     * @description 获取商机筛选列表
     * @author lee
     * @date 2021-06-07
     *
    */
    querySimpleList () {
      querySimpleList({
        createContractFlag: 1
      }).then(response => {
        const {code, msg, data} = response
        if (code == 200) {
          this.businessList = data || [];
        } else {
          this.$message.error(msg || '商机列表获取失败')
        }
      }).catch(error => {
        this.$message.error(error.msg || '商机列表获取失败')
      });
    },
    handleTabClick (tab) {
      if (tab.name === 'contractInfo') {
        if (this.$refs.contractInfoRef) this.$refs.contractInfoRef.queryList()
      } else if (tab.name === 'contractInvoice') {
        this.$refs.invoiceListRef.queryList()
      } else if (tab.name === 'deliver') {
        this.$refs.deliverListRef.queryList()
      } else if (tab.name === 'fulfillment') {
        this.queryFulfillmentProject()
      } else if (tab.name === 'financeOverview') {
        this.queryFinanceOverview()
      }
    },
    queryFinanceOverview () {
      const contractId = this.detail.id || this.$route.params.id
      if (!contractId) {
        return
      }
      this.financeOverviewLoading = true
      queryContractFinanceOverview({ id: contractId }).then(response => {
        this.financeOverview = this.normalizeFinanceOverview(response.data || null)
      }).finally(() => {
        this.financeOverviewLoading = false
      })
    },
    normalizeFinanceOverview (overview) {
      if (!overview) {
        return null
      }
      return Object.assign({
        contractSummary: {},
        receivableSummary: {},
        invoiceSummary: {},
        costSummary: {},
        profitSummary: {},
        riskList: [],
        sourceList: []
      }, overview)
    },
    switchFinanceTarget (targetName) {
      if (!targetName) {
        return
      }
      this.activeName = targetName
      this.$nextTick(() => {
        this.handleTabClick({ name: targetName })
      })
    },
    financeAmount (value) {
      return amountFormat(Number(value || 0))
    },
    financePercent (value) {
      const numberValue = Number(value || 0)
      return numberValue.toFixed(2) + '%'
    },
    financeText (value) {
      return value === undefined || value === null || value === '' ? '-' : value
    },
    financeRiskType (level) {
      const map = {
        danger: 'error',
        warning: 'warning',
        info: 'info',
        success: 'success'
      }
      return map[level] || 'info'
    },
    queryFulfillmentProject () {
      if (!this.detail.id && !this.$route.params.id) {
        return
      }
      this.fulfillmentLoading = true
      getFulfillmentByContractId(this.detail.id || this.$route.params.id).then(response => {
        this.fulfillmentProject = this.normalizeFulfillmentProject(response.data || null)
      }).finally(() => {
        this.fulfillmentLoading = false
      })
    },
    normalizeFulfillmentProject (project) {
      if (!project) {
        return null
      }
      project.requirementList = project.requirementList || []
      project.procurementFileObjs = (project.procurementFileObjs || []).map(item => Object.assign({}, item, {
        uid: item.uid || item.id
      }))
      return project
    },
    handleAutoCreateFulfillment () {
      this.$confirm('系统将按合同商品和交付与成本构成生成采购需求底稿，确认继续？', '提示', {
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.fulfillmentLoading = true
        autoCreateFulfillment({
          contractId: this.detail.id,
          projectName: `${this.detail.contractNum || this.detail.contractName || '合同'}履约项目`,
          remark: '按合同商品和交付与成本构成自动生成采购需求底稿'
        }).then(response => {
          this.fulfillmentProject = this.normalizeFulfillmentProject(response.data || null)
          this.msgSuccess('履约项目已生成')
        }).finally(() => {
          this.fulfillmentLoading = false
        })
      })
    },
    handleManualCreateFulfillment () {
      this.$confirm('将先创建空履约项目，后续由人工新增采购需求，确认继续？', '提示', {
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.fulfillmentLoading = true
        manualCreateFulfillment({
          contractId: this.detail.id,
          projectName: `${this.detail.contractNum || this.detail.contractName || '合同'}履约项目`,
          remark: '手动创建履约项目，采购需求由人工维护'
        }).then(response => {
          this.fulfillmentProject = this.normalizeFulfillmentProject(response.data || null)
          this.msgSuccess('履约项目已创建')
        }).finally(() => {
          this.fulfillmentLoading = false
        })
      })
    },
    openRequirementDialog (row, mode) {
      if (!this.fulfillmentProject || !this.fulfillmentProject.id) {
        this.$message.warning('请先创建履约项目')
        return
      }
      this.requirementDialogMode = mode || 'add'
      const source = row ? JSON.parse(JSON.stringify(row)) : {}
      this.requirementForm = Object.assign({
        id: null,
        fulfillmentProjectId: this.fulfillmentProject.id,
        itemType: 1,
        supplyMode: '采购',
        requirementQuantity: 1,
        unit: '',
        standardUnitCost: null,
        estimatedAmount: null,
        supplierName: '',
        confirmedUnitPrice: null,
        confirmedAmount: null,
        expectArrivalDate: null,
        remark: ''
      }, source, {
        fulfillmentProjectId: this.fulfillmentProject.id
      })
      this.requirementDialogVisible = true
      this.$nextTick(() => {
        if (this.$refs.requirementForm) {
          this.$refs.requirementForm.clearValidate()
        }
      })
    },
    handleProcurementFileChange (fileObjs) {
      if (this.fulfillmentProject) {
        this.$set(this.fulfillmentProject, 'procurementFileObjs', fileObjs || [])
      }
    },
    handleSaveProcurementFiles () {
      if (!this.fulfillmentProject || !this.fulfillmentProject.id) {
        this.$message.warning('请先创建履约项目')
        return
      }
      this.procurementFileSaving = true
      saveProcurementFiles({
        fulfillmentProjectId: this.fulfillmentProject.id,
        procurementFileObjs: this.fulfillmentProject.procurementFileObjs || []
      }).then(response => {
        this.fulfillmentProject = this.normalizeFulfillmentProject(response.data || null)
        this.msgSuccess('采购单附件已保存')
      }).finally(() => {
        this.procurementFileSaving = false
      })
    },
    submitRequirement () {
      this.$refs.requirementForm.validate(valid => {
        if (!valid) {
          return
        }
        const action = this.requirementDialogMode === 'confirm'
          ? confirmProcurementRequirement
          : saveProcurementRequirement
        const params = JSON.parse(JSON.stringify(this.requirementForm))
        this.fulfillmentLoading = true
        action(params).then(response => {
          this.fulfillmentProject = this.normalizeFulfillmentProject(response.data || null)
          this.requirementDialogVisible = false
          this.msgSuccess('操作成功')
        }).finally(() => {
          this.fulfillmentLoading = false
        })
      })
    },
    handleTransferRequirement (row) {
      this.$confirm('转采购后表示该需求已经进入后续采购执行，本页面不再允许编辑，确认继续？', '提示', {
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.fulfillmentLoading = true
        transferProcurementRequirement(row.id).then(response => {
          this.fulfillmentProject = this.normalizeFulfillmentProject(response.data || null)
          this.msgSuccess('已转采购')
        }).finally(() => {
          this.fulfillmentLoading = false
        })
      })
    },
    handleCancelRequirement (row) {
      this.$confirm('作废后该采购需求不再计入预计成本和采购状态，确认作废？', '警告', {
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.fulfillmentLoading = true
        cancelProcurementRequirement(row.id).then(response => {
          this.fulfillmentProject = this.normalizeFulfillmentProject(response.data || null)
          this.msgSuccess('已作废')
        }).finally(() => {
          this.fulfillmentLoading = false
        })
      })
    },
    sourceModeText (value) {
      return Number(value) === 2 ? '手动创建' : '合同自动生成'
    },
    procurementStatusText (value) {
      const map = {
        10: '待生成',
        20: '待确认',
        30: '部分确认',
        40: '已确认'
      }
      return map[Number(value)] || '-'
    },
    itemTypeText (value) {
      const item = this.requirementItemTypeOptions.find(option => Number(option.value) === Number(value))
      return item ? item.label : '-'
    },
    requirementStatusText (value) {
      const map = {
        10: '待确认',
        20: '已确认',
        30: '已转采购',
        90: '已作废'
      }
      return map[Number(value)] || '-'
    },
    requirementStatusType (value) {
      const map = {
        10: 'warning',
        20: 'success',
        30: '',
        90: 'info'
      }
      return map[Number(value)] || 'info'
    },
    canEditRequirement (row) {
      return ![30, 90].includes(Number(row.confirmStatus))
    },
    canConfirmRequirement (row) {
      return ![30, 90].includes(Number(row.confirmStatus))
    },
    canTransferRequirement (row) {
      return Number(row.confirmStatus) === 20
    },
    canCancelRequirement (row) {
      return ![30, 90].includes(Number(row.confirmStatus))
    },
    requirementRiskText (row) {
      if (Number(row.confirmStatus) === 90) {
        return '已作废'
      }
      if (!row.requirementQuantity || Number(row.requirementQuantity) <= 0) {
        return '数量待确认'
      }
      if (!row.standardUnitCost || Number(row.standardUnitCost) <= 0) {
        return '标准成本待完善'
      }
      if (!row.estimatedAmount || Number(row.estimatedAmount) <= 0) {
        return '预计金额待完善'
      }
      if (Number(row.confirmStatus) >= 20 && !row.supplierName) {
        return '供应商待补充'
      }
      return Number(row.confirmStatus) === 10 ? '待采购确认' : '正常'
    },
    refreshDetailAndLog() {
      this.queryDetail()
      this.refreshOperateLogList();
      this.$refs.deliverListRef.queryList()
    },
    refreshDetailAndLogAndApprovalRecord() {
      this.queryDetail()
      this.refreshOperateLogList();
      this.$refs.approveInfo.getList()
      this.$refs.deliverListRef.queryList()
    },
    queryDetail () {
      queryContractDetail({id:this.$route.params.id}).then(response => {
        if (response.data) {
          this.detail = response.data
          // this.detail.contractCompositionList.map(item => {
          //   this.queryProductModelList(item, false)
          // })
          if (this.activeName === 'fulfillment') {
            this.queryFulfillmentProject()
          } else if (this.activeName === 'financeOverview') {
            this.queryFinanceOverview()
          }
        } else {
          this.msgError("查询不到此合同");
        }
      }).catch(error => {
        this.detail = {}
      })
    },
    exportContractDocument() {
      if (!this.detail || !this.detail.id) {
        this.$message.warning('请先打开有效合同')
        return
      }
      download.post('/crmContract/exportContractDocument', { id: this.detail.id })
    },
    handleElContractFileChange (fileObjs) {
      this.updateData.elContractFileObjs = fileObjs;
      this.$refs['updateForm'].validateField('elContractFileObjs', (valid) => {
      })
    },
    handleFileChange (fileObjs) {
      this.updateData.fileObjs = fileObjs;
    },
    handleAfterFollowAdd () {
      this.$refs.followListRef.refresh()
      this.queryDetail()
    },
    handleAfterWorkPlanAdd () {
      this.refreshOperateLogList();
      this.$refs["followListRef"].refresh()
    },
    refreshOperateLogList () {
      this.$refs.operateLogListRef.refresh()
    },
    handleAfterPlanFundQuery (list) {
      this.contractPlanFundCount = list.length;
    },
    handleAfterDeliverQuery (deliverList) {
      this.deliverCount = deliverList.length
    },
    handleAfterFundRecordQuery (list) {
      this.contractFundRecordCount = list.length;
    },
    handleAfterInvoiceQuery (list) {
      this.contractInvoiceCount = list.length;
    },
    handleEdit () {
      this.$nextTick(() => {
        let detail = JSON.parse(JSON.stringify(this.detail))
        detail.area = []
        if (detail.provinceCode) {
          detail.area.push(detail.provinceCode)
          if (detail.cityCode) {
            detail.area.push(detail.cityCode)
            if (detail.regionCode) detail.area.push(detail.regionCode)
          }
        }
        this.updateData = detail
        this.updateData.hasMembrane = detail.hasMembrane === true || Number(detail.membraneArea) > 0
        if (!this.updateData.hasMembrane) this.updateData.membraneArea = 0
        this.updateData.fileObjs = this.detail.fileUrls || [];
        this.editModel = true
        this.customerList = [{id: this.updateData.customerId, customerName: this.updateData.customerName}]
      }, 1)
    },
    handleHasMembraneChange (checked) {
      if (!checked) {
        this.updateData.membraneArea = 0
      }
      this.$nextTick(() => {
        if (this.$refs.updateForm) this.$refs.updateForm.clearValidate('membraneArea')
      })
    },
    isRentalContractType (contractType) {
      if (contractType === '设备租赁') return true
      const option = this.typeOptions.find(item => item.dictValue === contractType)
      return !!(option && option.dictLabel === '设备租赁')
    },
    handleContractTypeChange () {
      this.$nextTick(() => {
        if (this.$refs.updateForm) this.$refs.updateForm.clearValidate('contractEndDate')
      })
    },
    handleEditSave () {
      this.$refs['updateForm'].validate((valid) => {
        if (valid) {
          if (this.updateData.hasMembrane && !(Number(this.updateData.membraneArea) > 0)) {
            this.$message.error('含膜合同的膜面积必须大于0')
            return
          }
          if (this.isRentalContractType(this.updateData.contractType) && !this.updateData.contractEndDate) {
            this.$message.error('请选择租赁到期时间')
            return
          }
          if (this.isRentalContractType(this.updateData.contractType) && this.updateData.contractSignDate
            && this.updateData.contractEndDate < this.updateData.contractSignDate) {
            this.$message.error('租赁到期时间不能早于签约日期')
            return
          }
          if (this.totalAmount < 0) {
            this.$message.error('总金额不能小于0')
            return
          }
          let params = JSON.parse(JSON.stringify(this.updateData));
          params.provinceCode = params.area && params.area.length > 0 ? params.area[0] : null
          params.cityCode = params.area && params.area.length > 1 ? params.area[1] : null
          params.regionCode = params.area && params.area.length > 2 ? params.area[2] : null
          params.compositionUpdateFlag = true
          if (params.fileObjs && params.fileObjs.length > 0) {
            params.fileObjs = params.fileObjs.map(item => {
              return { id: item.id };
            })
          }
          if (!params.contractCompositionList.length) {
            this.$message.error('请添加合同构成')
            return
          } else {
            // 判断参数必填项
            try {
              params.contractCompositionList.forEach(item => {
                if (!item.productType) throw new Error('请选择产品类型')
                if (!item.contractUsage || item.contractUsage <= 0) throw new Error('请填写大于0的合同用量')
                if (!item.usageUnit) throw new Error('请选择用量单位')
                if (!item.amount || item.amount <= 0) throw new Error('请填写大于0的合同金额')
              })
            } catch (e) {
              this.$message.error(e.message || '请检查合同构成必填项')
              return
            }
          }
          const loading = this.$loading({
            lock: true,
            text: '加载中',
            spinner: 'el-icon-loading'
          });
          updateContract(params).then(response => {
            this.refreshDetailAndLog();
            this.editModel = false
            loading.close();
            this.msgSuccess("更新成功");
          }).catch(error => {
            loading.close()
          })
        } else {
          this.msgWarning("请检查必填项");
          return false;
        }
      });
    },
    /** 详细按钮操作 */
    toCustomerDetail(type) {
      if (type == 'ownerCustomer') {
        this.$router.push("/crm/customer/detail/" + this.detail.ownerCustomerId);
      } else {
        this.$router.push("/crm/customer/detail/" + this.detail.customerId);
      }
    },
    /** 详细按钮操作 */
    toBusinessDetail() {
      this.$router.push("/crm/business/detail/" + this.detail.businessId);
    },
    /** 分配按钮操作 */
    handleAssign() {
      this.$refs.assignDialogRef.singleAssign("contract", this.detail.id)
    },
    handleGroupMemberSuccess(userId) {
      if (this.currentUserId === userId) {
        this.queryDetail()
      }
      this.refreshOperateLogList()
      if (this.$refs.followAddRef) {
        this.$refs.followAddRef.queryAtList()
        this.$refs.workPlanRef.queryAtList()
      }
    },
  }
};
</script>
<style lang="scss" scoped>
.sidebar-toggle {
  width: 100%;
  text-align: right;
  margin-bottom: 8px;
}
.card-item {
  border-radius: 6px;
  padding: 20px;
  border: 1px solid #d9d9d9;
  margin-bottom: 20px;
}
.card-title {
  margin: 0 0 15px 15px;
  border-left: 3px solid #4480F3;
  padding-left: 15px;
  font-size: 17px;
  font-weight: bold;
}
.fulfillment-empty {
  min-height: 280px;
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  background: #fafafa;
}
.fulfillment-empty-title {
  color: #606266;
  font-size: 16px;
  margin-bottom: 18px;
}
.fulfillment-actions .el-button + .el-button {
  margin-left: 12px;
}
.fulfillment-meta {
  margin: 16px 0 8px;
  line-height: 36px;
}
.fulfillment-name {
  font-size: 16px;
  font-weight: bold;
  color: #303133;
  margin-right: 10px;
}
.group-member {
  width: 120px;
  margin-bottom: 20px;
  height: 40px;

  .group-member-remove-btn {
    margin-left: -5px;
    cursor: pointer;
    position: absolute;
  }
  .value {
    width: 75px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    -o-text-overflow: ellipsis;
  }
  .avatar {
    float: left;
  }
  .name {
    margin-left: 45px;
    line-height: 50px;
    margin-top: -12px;
  }
}
.group-member-add-btn{
    width: 40px;
    height: 40px;
    text-align: center;
    border-radius: 50%;
    padding: 0 0 0 2px;
    position: absolute;
    top: -12px;
}
.text-style {
  font-size: 14px;
  margin-bottom: 10px;
  margin-left: 15px;
}

::v-deep .red-text {
  color: red;
}

.approvelDesc {
  position: absolute;
  right: 30px;
  top: 5px;
}
.desc-info {
  font-weight: 400;
}

.amountContainer {
  border: 1px solid #dfe4ed;
  width: 100%;
  height: 80px;
  padding-left: 10px;
  padding-top: 10px;
  line-height: 30px;
}

.row-margin {
  margin-top: 15px;
}

.fulfillment-alert {
  margin-bottom: 14px;
}

.fulfillment-empty {
  padding: 56px 20px;
  text-align: center;
  border: 1px dashed #d9dfe9;
  background: #fafcff;
}

.fulfillment-empty-title {
  font-size: 18px;
  font-weight: 600;
  color: #303133;
  margin-bottom: 10px;
}

.fulfillment-empty-desc {
  font-size: 14px;
  color: #606266;
  margin-bottom: 18px;
}

.fulfillment-summary {
  margin-top: 14px;
}

.fulfillment-stat {
  border: 1px solid #dfe4ed;
  padding: 12px 14px;
  min-height: 76px;
  background: #fff;
}

.fulfillment-stat-label {
  font-size: 13px;
  color: #909399;
  margin-bottom: 8px;
}

.fulfillment-stat-value {
  font-size: 17px;
  color: #303133;
  font-weight: 600;
  word-break: break-all;
}

.fulfillment-project-name {
  color: #303133;
  font-size: 16px;
  font-weight: 600;
}

.finance-overview {
  min-height: 560px;
  padding: 10px 0 4px;
}

.finance-overview-head {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 12px;
  margin-bottom: 12px;
}

.finance-overview-title {
  color: #303133;
  font-size: 18px;
  font-weight: 600;
  line-height: 28px;
}

.finance-overview-desc {
  color: #909399;
  font-size: 13px;
  line-height: 22px;
}

.finance-overview-actions {
  flex-shrink: 0;
  text-align: right;
}

.finance-overview-actions .el-button {
  margin-bottom: 6px;
}

.finance-section {
  border: 1px solid #e4e7ed;
  background: #fff;
  padding: 14px;
  margin-bottom: 12px;
}

.finance-section-title {
  color: #303133;
  font-size: 15px;
  font-weight: 600;
  margin-bottom: 12px;
}

.finance-meta-item {
  min-height: 64px;
  border: 1px solid #edf0f5;
  background: #fafbfc;
  padding: 10px 12px;
  margin-bottom: 8px;
}

.finance-meta-item span,
.finance-kpi-label,
.finance-kpi-sub,
.finance-note {
  color: #909399;
  font-size: 13px;
}

.finance-meta-item strong {
  display: block;
  color: #303133;
  font-size: 14px;
  line-height: 22px;
  margin-top: 6px;
  word-break: break-all;
}

.finance-kpi-grid {
  margin-bottom: 12px;
}

.finance-kpi {
  min-height: 112px;
  border: 1px solid #dfe4ed;
  background: #fff;
  padding: 14px;
  margin-bottom: 12px;
}

.finance-kpi-value {
  color: #303133;
  font-size: 22px;
  font-weight: 600;
  line-height: 34px;
  margin: 8px 0 4px;
  word-break: break-all;
}

.finance-row {
  display: flex;
  justify-content: space-between;
  gap: 12px;
  min-height: 34px;
  line-height: 34px;
  border-bottom: 1px solid #f0f2f5;
}

.finance-row span {
  color: #606266;
}

.finance-row strong {
  color: #303133;
  text-align: right;
  word-break: break-all;
}

.finance-row-strong span,
.finance-row-strong strong {
  font-weight: 600;
}

.finance-note {
  margin-top: 10px;
  line-height: 22px;
}

.finance-alert {
  margin-bottom: 8px;
}

.finance-empty {
  height: 240px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #909399;
  border: 1px dashed #d9dfe9;
  background: #fafcff;
}

.procurement-file-section {
  border: 1px solid #e4e7ed;
  border-radius: 4px;
  padding: 12px;
  margin-top: 12px;
  background: #fff;
}

.procurement-file-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 10px;
}

.procurement-file-title {
  color: #303133;
  font-size: 14px;
  font-weight: 600;
  margin-bottom: 4px;
}

.muted-text {
  color: #909399;
  font-size: 12px;
}

.warning-text {
  color: #e6a23c;
}

.danger-text {
  color: #f56c6c;
}
</style>
